import { apiClient } from './api';

// Position 타입 정의
export interface Position {
  id: number;
  name: string;
  sortOrder: number;
  isActive: boolean;
  unitCost: number; // 직급원가 (만원 단위)
}

export interface CreatePositionDto {
  name: string;
  sortOrder?: number;
  isActive?: boolean;
  unitCost?: number;
}

export interface UpdatePositionDto {
  name?: string;
  sortOrder?: number;
  isActive?: boolean;
  unitCost?: number;
}

export const positionApi = {
  // 모든 직급 조회 (기본: 활성화된 직급만)
  getAll: (includeInactive = false): Promise<Position[]> => {
    const query = includeInactive ? '?includeInactive=true' : '';
    return apiClient.get<Position[]>(`/positions${query}`);
  },

  // 직급 단건 조회
  getById: (id: number): Promise<Position> => {
    return apiClient.get<Position>(`/positions/${id}`);
  },

  // 직급 생성
  create: (dto: CreatePositionDto): Promise<Position> => {
    return apiClient.post<Position>('/positions', dto);
  },

  // 직급 수정
  update: (id: number, dto: UpdatePositionDto): Promise<Position> => {
    return apiClient.patch<Position>(`/positions/${id}`, dto);
  },

  // 직급 삭제
  delete: (id: number): Promise<{ message: string }> => {
    return apiClient.delete<{ message: string }>(`/positions/${id}`);
  },

  // 직급 순서 변경
  reorder: (positionIds: number[]): Promise<Position[]> => {
    return apiClient.post<Position[]>('/positions/reorder', { positionIds });
  },

  // 이름으로 직급 조회 또는 생성 (직원 등록 시 새 직급 추가용)
  findOrCreate: (name: string): Promise<Position> => {
    return apiClient.post<Position>('/positions/find-or-create', { name });
  },
};
